export const AIContentFields = {
  aiTranscript: "Transcript",
  aiSummary: "Summary",
  facebookPost: "Facebook Post",
  instagramPost: "Instagram Caption",
  linkedinPost: "LinkedIn Post",
  showNotes: "Episode Show Notes",
  singleTweet: "Single Threads Post",
  tweetThread: "Threads Multi-Post",
  instagramReel: "Instagram Reels Script",
  emailNewsletter: "Email Newsletter",
  episodeTitles: "Episode Titles",
  blogPost: "Blog Post",
  youtubeDescription: "YouTube Description",
  introductionOverview: "Introduction/Overview",
  hashtags: "Hashtags",
};

export const AiContentData1 = [
  { label: "Transcript", field: "aiTranscript" },
  { label: "Summary", field: "aiSummary" },
  { label: "Facebook Post", field: "facebookPost" },
  { label: "Instagram Caption", field: "instagramPost" },
  { label: "LinkedIn Post", field: "linkedinPost" },
  { label: "Single Threads Post", field: "singleTweet" },
  { label: "Threads Multi-Post", field: "tweetThread" },
];

export const AiContentData2 = [
  { label: "Blog Post", field: "blogPost" },
  { label: "YouTube Description", field: "youtubeDescription" },
  { label: "Episode Show Notes", field: "showNotes" },
  { label: "Episode Titles", field: "episodeTitles" },
  { label: "Introduction/Overview", field: "introductionOverview" },
  { label: "Hashtags", field: "hashtags" },
  { label: "Instagram Reels Script", field: "instagramReel" },
  { label: "Email Newsletter", field: "emailNewsletter" },
];
